import excuseApi from '../api/excuseApi';

const CommentModel = {
  id: null,
  parent_id: null,    // 🆕 hỗ trợ subcomment
  target_type: '',    // 🆕 'article' | 'feeling'
  target_id: null,    // 🆕 id của article hoặc feeling
  article_id: null,   // null nếu target_type = 'feeling'
  account_id: null,
  username: '',
  content: '',
  created_at: '',
};

export const createComment = (data) =>
  excuseApi({
    endpoint: '/comments',
    method: 'POST',
    data,
  });

// 🟢 Lấy comment theo ID
export const getCommentById = (id) =>
  excuseApi({
    endpoint: `/comments/${id}`,
    method: 'GET',
  });

// 🟢 Lấy danh sách comment theo article_id
export const getCommentsByArticle = (article_id) =>
  excuseApi({
    endpoint: `/articles/${article_id}/comments`,
    method: 'GET',
  });

// 🟢 Lấy danh sách comment theo feeling_id
export const getCommentsByFeeling = (feeling_id) =>
  excuseApi({
    endpoint: `/feelings/${feeling_id}/comments`,
    method: 'GET',
  });

// 🟢 Lấy subcomments theo comment cha
export const getSubcomments = (parent_id) =>
  excuseApi({
    endpoint: `/comments/${parent_id}/subcomments`,
    method: 'GET',
  });

// 🟢 Cập nhật comment theo id
export const updateComment = (id, content) =>
  excuseApi({
    endpoint: `/comments/${id}`,
    method: 'PUT',
    data: { content },
  });

// 🔴 Xoá comment theo id
export const deleteComment = (id) =>
  excuseApi({
    endpoint: `/comments/${id}`,
    method: 'DELETE',
  });


  export const getComments = async ({ target_type, target_id, page = 1, per_page = 10 }) => {
    const res = await excuseApi({
      endpoint: `/comments?target_type=${target_type}&target_id=${target_id}&page=${page}&per_page=${per_page}`,
      method: 'GET',
    });
    return res;
  }

const Comment = {
  createComment,
  getCommentById,
  getCommentsByArticle,
  getCommentsByFeeling,
  getSubcomments,
  updateComment,
  deleteComment,
};

export { CommentModel };
export default Comment;
